<template>
  <div class="musteriler">
    <AppMain>
      <div class="container">
        <div class="page-title-container">
          <div class="row">
            <div class="col-12 col-md-7">
              <h1 class="mb-0 pb-0 display-4" id="title">Müşteriler</h1>
              <nav class="breadcrumb-container d-inline-block" aria-label="breadcrumb">
                <ul class="breadcrumb pt-0">
                  <li class="breadcrumb-item">
                    <router-link to="/">Anasayfa</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/musteriler">Müşteriler</router-link>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-12 col-md-5 d-flex align-items-start justify-content-end">
              <button
                v-if="yetki_kontrol('musteri_ekle')"
                class="btn btn-outline-primary btn-icon btn-icon-start w-100 w-md-auto"
                @click="musteriler_ekle"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                  class="acorn-icons acorn-icons-plus undefined">
                  <path d="M10 17 10 3M3 10 17 10"></path>
                </svg>
                <span>Müşteri Ekle</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-sm-12 col-md-5 col-lg-3 col-xxl-2 mb-1">
            <div class="d-inline-block float-md-start me-1 mb-1 search-input-container w-100 shadow bg-foreground">
              <input class="form-control" placeholder="Müşteri ara..." v-model="musteriler.arananKelime" />
              <span class="search-magnifier-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                  class="acorn-icons acorn-icons-search undefined">
                  <circle cx="9" cy="9" r="7"></circle>
                  <path d="M14 14L17.5 17.5"></path>
                </svg>
              </span>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 col-lg-9 col-xxl-10 text-end mb-1">
            <div class="d-inline-block">
              <div class="dropdown-as-select d-inline-block ms-1" data-childselector="span">
                <button class="btn p-0 shadow" type="button" data-bs-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false" data-bs-offset="0,3">
                  <span class="btn btn-foreground-alternate dropdown-toggle" data-bs-toggle="tooltip"
                    data-bs-placement="top" data-bs-delay="0" title="" data-bs-original-title="Item Count">
                    {{ musteriler.sayfadaKayit }} Adet
                  </span>
                </button>
                <div class="dropdown-menu shadow dropdown-menu-end">
                  <a class="dropdown-item" href="#" @click.prevent="musterilerSayfadaKayitDegistir(6)">6 Adet</a>
                  <a class="dropdown-item" href="#" @click.prevent="musterilerSayfadaKayitDegistir(12)">12 Adet</a>
                  <a class="dropdown-item" href="#" @click.prevent="musterilerSayfadaKayitDegistir(24)">24 Adet</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <musteriCard
            :musteriler="musteriler"
            :duzenle="musteriler_duzenle"
            :formKaydetSonrasi="musterilerYenile"
            @update:musteriler="musterilerGuncelle"
            @isEkle="isler_ekle"
          />
        </div>
      </div>
    </AppMain>

    <div class="modal fade modal-close-out show" style="display: block;" v-if="musteriler.modal">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="musteriler.islem === 'ekle'">Yeni Müşteri Ekle</h5>
            <h5 class="modal-title" v-if="musteriler.islem === 'duzenle'">Müşteri Düzenleme</h5>
            <button type="button" class="btn-close" @click="musteriler_iptal"></button>
          </div>
          <div class="modal-body">
            <musteriForm
              :formIslem="musteriler.islem"
              :formData="musteriler.secili"
              :formKaydetSonrasi="musterilerYenile"
              :formIptal="musteriler_iptal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade modal-close-out show" style="display: block;" v-if="isler.modal">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="isler.islem === 'ekle'">Yeni İş Ekle</h5>
            <h5 class="modal-title" v-if="isler.islem === 'duzenle'">İş Düzenleme</h5>
            <button type="button" class="btn-close" @click="isler_iptal"></button>
          </div>
          <div class="modal-body">
            <isForm
              :formIslem="isler.islem"
              :formData="isler.secili"
              :formKaydetSonrasi="islerYenile"
              :formIptal="isler_iptal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";
import musteriCard from "@/components/musteriler/musteriCard.vue";
import musteriForm from "@/components/musteriler/musteriForm.vue";
import isForm from "@/components/isler/isForm.vue";
import { getModulePageSize, setModulePageSize } from "@/services/paginationSettings";

export default {
  name: "musterilerView",
  components: {
    AppMain,
    musteriCard,
    musteriForm,
    isForm,
  },
  data() {
    return {
      musteriler: {
        tumu: [],
        secili: null,
        seciliSayfa: 1,
        sayfadaKayit: getModulePageSize("musteriler") || 12,
        arananKelime: "",
        islem: 'ekle',
        modal: false,
      },
      isler: {
        secili: null,
        islem: 'ekle',
        modal: false,
      },
    };
  },

  mounted() {
    this.musterilerGetir();
  },
  methods: {
    yetki_kontrol(yetki) {
      return yetkiKontrol(yetki);
    },
    musterilerGetir() {
      axiosCustom
        .get("musteriler")
        .then((response) => {
          this.musteriler.tumu = response.data;
        })
        .catch((error) => {
          console.error("Veri çekme hatası: ", error);
        });
    },
    musterilerYenile() {
      this.musterilerGetir();
      this.musteriler.modal = false;
    },
    musterilerGuncelle(veriler) {
      this.musteriler = veriler;
    },

    musteriler_ekle() {
      this.musteriler.secili = {};
      this.musteriler.islem = "ekle";
      this.musteriler.modal = true;
    },
    musteriler_duzenle(musteri) {
      this.musteriler.secili = musteri;
      this.musteriler.islem = "duzenle";
      this.musteriler.modal = true;
    },
    musteriler_iptal() {
      this.musteriler.secili = {};
      this.musteriler.modal = false;
    },

    musterilerSayfadaKayitDegistir(value) {
      this.musteriler.sayfadaKayit = value;
      setModulePageSize("musteriler", value);
      this.musteriler.seciliSayfa = 1;
    },

    isler_ekle(musteri) {
      this.isler.secili = { musteri: musteri.id };
      this.isler.islem = "ekle";
      this.isler.modal = true;
    },
    islerYenile() {
      this.isler.modal = false;
      this.isler.secili = {};
      this.musterilerGetir();
    },
    isler_iptal() {
      this.isler.secili = {};
      this.isler.modal = false;
    },
  },
};
</script>
